import { render, staticRenderFns } from "./RatingCreate.vue?vue&type=template&id=8ca8ff52&scoped=true&"
import script from "./RatingCreate.vue?vue&type=script&lang=js&"
export * from "./RatingCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca8ff52",
  null
  
)

export default component.exports